export default __webpack_public_path__ + "static/media/logo_WhiteBackground.d3e557d5.svg";